// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1clYr","actions":"GroupTable_actions__2rvBE","deleteModalFooter":"GroupTable_deleteModalFooter__1c8AG"};